export default __webpack_public_path__ + "static/media/Just_4_logo_white.ff99b268.svg";